import { Container, Sprite, Texture, Point, Graphics } from 'pixi.js';
import { app } from '../app';
import { ScriptRunner } from './ScriptRunner';
import { storageManager } from './../common/StorageManager';
import { dataImporter } from './../DataImporter';

export class MissionRunner {
    constructor(game, neededExtras) {
        this.game = game;

        this.tilemap = game.tilemap;
        this.worldUI = game.worldUI;
        this.screenUI = game.screenUI;
        this.camera = game.camera;
        this.player = game.player;
        this.aiController = game.aiController;
        this.neededExtras = neededExtras;

    }

    init(missionData) {
        this.missionData = missionData;

        // Briefing
        this.briefing = this.buildBriefing(this.missionData.briefing);

        this.script = ScriptRunner.processScript(this, missionData.script);
        //if (this.script) this.script.setOnFalse(this.checkIfFinished);
    }

    buildBriefing(briefingData) {
        let briefing = new Container();

        if (!briefingData ?.bg ?.image || !briefingData ?.char ?.image || !briefingData ?.obj ?.image) {
            console.warn('Failed to find data for a briefing.');
            return;
        }

        briefing.screen = new Container();
        briefing.addChild(briefing.screen);

        briefing.bg = new Sprite.from(briefingData.bg.image);
        briefing.bg.anchor.set(0.5);

        briefing.bgColour = new Sprite();
        briefing.bgColour.texture = Texture.WHITE;
        briefing.bgColour.tint = 0x000000;
        briefing.bgColour.anchor.set(0.5);
        briefing.bgColour.width = app.resizer.width;
        briefing.bgColour.height = briefing.bg.height;

        briefing.screen.addChild(briefing.bgColour, briefing.bg);

        briefing.char = new Sprite.from(briefingData.char.image);
        briefing.char.anchor.set(0.5);
        briefing.char.visible = false;
        briefing.char.targetPos = new Point(-400, 50);
        briefing.screen.addChild(briefing.char);

        briefing.obj = new Sprite.from(briefingData.obj.image);
        briefing.obj.anchor.set(0.5);
        briefing.obj.visible = false;
        briefing.obj.targetPos = new Point(400, -100);
        briefing.screen.addChild(briefing.obj);

        briefing.bars = this.makeBlackBars();
        briefing.addChild(briefing.bars);

        Object.keys(briefingData).forEach((key) => {
            if (!briefingData[key].pos || !briefing[key].targetPos) return;
            if (briefingData[key].pos.x) briefing[key].targetPos.x = briefingData[key].pos.x;
            if (briefingData[key].pos.y) briefing[key].targetPos.y = briefingData[key].pos.y;
        });

        briefing.resize = () => {
            this.bgColour.width = app.resizer.width;
            this.bgColour.height = app.resizer.height;
            this.background.height = this.app.resizer.height;
            this.background.scale.x = this.background.scale.y;
        };

        briefing.reset = () => {
            briefing.screen.alpha = 0;
            briefing.visible = true;

            briefing.char.x -= app.resizer.width + briefing.char.width;
            briefing.char.y = 0;
            briefing.char.visible = true;

            briefing.obj.position.copyFrom(briefing.obj.targetPos);
            briefing.obj.scale.set(0);
            briefing.obj.visible = true;

            briefing.bars.reset();
        };

        briefing.start = (screenUI) => {
            briefing.reset();

            screenUI.addChild(briefing);

            app.tween(briefing.screen)
                .wait(250)
                .call(() => briefing.bars.open())
                .wait(300)
                .to({ alpha: 1 }, 500).call(() => {
                    app.tween(briefing.char).to({ x: briefing.char.targetPos.x, y: briefing.char.targetPos.y }, 1000);

                    app.tween(briefing.obj.scale)
                        .wait(1500)
                        .to({ x: 1, y: 1 }, 250);

                    app.tween(briefing.screen)
                        .wait(5000)
                        .to({ alpha: 0 }, 500)
                        .call(() => briefing.bars.close())
                        .wait(300)
                        .call(() => {
                            this.player.lock(false);
                            this.startMission();
                            briefing.visible = false;
                            screenUI.removeChild(briefing);
                        });
                });
        };

        return briefing;
    }

    startBriefing(screenUI) {
        this.player.lock(true);
        this.briefing.start(screenUI);
    }

    startMission() {
        console.log('Mission Started.');
        if (storageManager.getShowTutorial){
            setTimeout(() => {
                this.game.startTutorial();
            }, 3000);
        }
        nick_sdk_client.GameEventEmitter.sendGameEvent(
            nick_sdk_client.GameEventEmitter.ON_LEVEL_START,
            dataImporter.currMission.id
        );
        this.script.run();
    }

    endMission() {
        console.log('Mission Finished.');
        this.player.lock(true);
        // storageManager.unlockMission(dataImporter.currPack, dataImporter.currMission);
        // console.log('Next level unlocked.');
        storageManager.setShowTutorial(false);
        nick_sdk_client.GameEventEmitter.sendGameEvent(
            nick_sdk_client.GameEventEmitter.ON_LEVEL_COMPLETE,
            dataImporter.currMission.id
        );

        nick_sdk_client.GameEventEmitter.sendGameEvent(
            nick_sdk_client.GameEventEmitter.ON_GAME_OVER,
            "win"
        );

        //Adding celebration audio
        app.sound.play("09-end-level");

        //Adding celebration animation
        app.tween(this).wait(250).call(() => {
            this.player.celebrate();

            app.tween(this).wait(6000).call(() => {
                app.showScreen('photoGallery', dataImporter.currPack.tags.photoGallery);
            });
        });
        //this.emit('missionEnd');
    }

    onInteract(data) {
        this.script.checkInteractionAt(data.interactPos);
    }

    makeBlackBars() {
        let blackBars = new Container();
        blackBars.top = makeBlackBar(blackBars.top);
        blackBars.top.anchor.set(0.5, 0);
        blackBars.top.y = (-app.resizer.height * 0.5) - blackBars.top.height;
        blackBars.addChild(blackBars.top);
        blackBars.bot = makeBlackBar(blackBars.bot);
        blackBars.bot.anchor.set(0.5, 1);
        blackBars.bot.y = (app.resizer.height * 0.5) + blackBars.bot.height;
        blackBars.addChild(blackBars.bot);

        blackBars.reset = () => {
            blackBars.top.y = (-app.resizer.height * 0.5) - blackBars.top.height;
            blackBars.bot.y = (app.resizer.height * 0.5) + blackBars.bot.height;
        };

        blackBars.open = () => {
            app.tween(blackBars.top)
                .to({ y: blackBars.top.y + blackBars.top.height }, 250);

            app.tween(blackBars.bot)
                .to({ y: blackBars.bot.y - blackBars.top.height }, 250);
        };

        blackBars.close = () => {
            app.tween(blackBars.top)
                .to({ y: blackBars.top.y - blackBars.bot.height }, 250);

            app.tween(blackBars.bot)
                .to({ y: blackBars.bot.y + blackBars.bot.height }, 250);
        };

        function makeBlackBar() {
            let blackBar = new Sprite(Texture.WHITE);
            blackBar.tint = 0x000000;
            blackBar.width = app.resizer.width;
            blackBar.height = 180;
            return blackBar;
        }

        return blackBars;
    }
}
